import { useState } from "react"
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap"
import cross from "../../assets/images/cross.png";
import { circleInfo } from "../../features/base64/images.constants";

export const CustomModal = (props) => {

    const [value, setValue] = useState(props.defaultValue);
    return(
        <Modal
            show={props.show}
            onHide={props.onHide}
            size={props.size}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter" >
                    Select Utility
                </Modal.Title>
                <Button
                    variant="outline"
                    onClick={props.onHide}
                    className="py-0 mt-2"
                >
                    {/* <img className="p-0 mb-1" src={cross} /> */}
                    <i className="fa fa-times fa-2x"></i>
                </Button>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Control
                                    as="select"
                                    onChange={(e) => {props.onChange(e.target.value); setValue(e.target.value)}}
                                    required={props.required}
                                    value={value}
                                >
                                    {props.options.map((i, index) => <option value={i.value} index={index}>{i.label}</option>)}
                                </Form.Control>
                                <Form.Text muted>
                                    <img className="ml-1" src={circleInfo} x="0" y="0" height="10px" width="10px" /> Select your utility provider from the diverse options available in this area
                                </Form.Text>
                            </Form.Group>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onClick}>
                    Select
                </Button>
            </Modal.Footer>
        </Modal>
    )
}